import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'forms/rrf';
import ConfirmPopup from '../../common/confirm-popup';
import RequiredPasswordMaskInput from '../../common/form/elements/required-password-mask-input';

const model = 'deep.my_profile_change_email_dialog';

class ChangeEmailDialog extends Component {
  render() {
    const { handleCloseDialog, formValid } = this.props;

    return (
      <ConfirmPopup
        confirmLabel="Save"
        header="CONFIRM PASSWORD"
        confirmDisabled={!formValid}
        onClose={handleCloseDialog}
      >
        <div className="ta-left">
          <p>
            Please enter your password.
          </p>
          <Form model={model}>
            <RequiredPasswordMaskInput
              controlId="password"
              placeholder="Password"
              model=".password"
            />
          </Form>
        </div>
      </ConfirmPopup>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.my_profile_change_email_dialog.$form.valid
});

export default connect(mapStateToProps)(ChangeEmailDialog);
